module.exports = __webpack_public_path__ + "static/app_icon-9b56080794abcc8a859309033836d432.png";